import { render, staticRenderFns } from "./UdefIcon.vue?vue&type=template&id=53fe8541&scoped=true&"
import script from "./UdefIcon.vue?vue&type=script&lang=js&"
export * from "./UdefIcon.vue?vue&type=script&lang=js&"
import style0 from "./UdefIcon.vue?vue&type=style&index=0&id=53fe8541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe8541",
  null
  
)

export default component.exports